// Copyright (c) 2022, HelmCyber, Inc.
'use strict'

import axios from 'axios'
import PropTypes from 'prop-types'
import { useEffect } from 'react'
import Modal from 'react-bootstrap/Modal'
import ProgressBar from 'react-bootstrap/ProgressBar'

const WaitModal = ({ title, msgTop, msgBottom, animate }) => {
    useEffect(() => {
        let source, pingInterval

        const setupPing = async () => {
            const sessionStartTime = (await axios.get('/systemManagement/ping')).data.startTime

            const ping = async () => {
                try {
                    const CancelToken = axios.CancelToken
                    source = CancelToken.source()

                    const recurringPingResponseData = (await axios.get('/systemManagement/ping', {
                        cancelToken: source.token,
                        customError: true,
                        noNetworkFailure: true,
                    })).data

                    if (recurringPingResponseData.startTime !== sessionStartTime) location.reload()
                } catch (err) {
                    if (!axios.isCancel(err) && err.response && err.response.status !== 0) {
                        window.location.reload()
                    }
                }
            }

            pingInterval = setInterval(() => {
                if (source) source.cancel()
                ping()
            }, 1000)
        }

        setupPing()

        return () => {
            if (pingInterval) clearInterval(pingInterval)
            if (source) source.cancel()
        }
    }, [])

    return (
        <Modal show={true} backdrop="static" keyboard={false}>
            <Modal.Header>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="text-center">
                <h3>{msgTop}</h3>
                {animate && <ProgressBar striped animated now={100} className="mb-3" />}
                <p>{msgBottom}</p>
            </Modal.Body>
        </Modal>
    )
}

WaitModal.propTypes = {
    title: PropTypes.string,
    msgTop: PropTypes.string,
    msgBottom: PropTypes.string,
    animate: PropTypes.bool,
}

WaitModal.defaultProps = {
    title: 'Restart',
    msgTop: 'Restarting Unit',
    msgBottom: 'Please Wait',
    animate: true,
}

export default WaitModal